import buildAsyncCall from './asyncCall'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'

const Types = {
    DASHBOARD_MEDIA_LATEST: {
        request: 'DASHBOARD_MEDIA_LATEST##REQUEST',
        success: 'DASHBOARD_MEDIA_LATEST##SUCCESS',
        failure: 'DASHBOARD_MEDIA_LATEST##FAILURE',
    },
    DASHBOARD_MEDIA_SCHEDULED_NEXT: {
        request: 'DASHBOARD_MEDIA_SCHEDULED_NEXT##REQUEST',
        success: 'DASHBOARD_MEDIA_SCHEDULED_NEXT##SUCCESS',
        failure: 'DASHBOARD_MEDIA_SCHEDULED_NEXT##FAILURE',
    },
    DASHBOARD_CDD_LAST_DOWNLOAD: {
        request: 'DASHBOARD_CDD_LAST_DOWNLOAD##REQUEST',
        success: 'DASHBOARD_CDD_LAST_DOWNLOAD##SUCCESS',
        failure: 'DASHBOARD_CDD_LAST_DOWNLOAD##FAILURE',
    },
}

function fetchMediaLatest() {
    return buildAsyncCall({
        endpoint: `${HUBBLE_API_TOKEN}/dashboard/media/latest`,
        method: 'GET',
        types: [Types.DASHBOARD_MEDIA_LATEST.request, Types.DASHBOARD_MEDIA_LATEST.success, Types.DASHBOARD_MEDIA_LATEST.failure],
    })
}

function fetchMediaScheduledNext() {
    return buildAsyncCall({
        endpoint: `${HUBBLE_API_TOKEN}/dashboard/media/scheduled/next`,
        method: 'GET',
        types: [Types.DASHBOARD_MEDIA_SCHEDULED_NEXT.request, Types.DASHBOARD_MEDIA_SCHEDULED_NEXT.success, Types.DASHBOARD_MEDIA_SCHEDULED_NEXT.failure],
    })
}

function fetchCDDLastDownload() {
    return buildAsyncCall({
        endpoint: `${HUBBLE_API_TOKEN}/dashboard/cdd/last-download`,
        method: 'GET',
        types: [Types.DASHBOARD_CDD_LAST_DOWNLOAD.request, Types.DASHBOARD_CDD_LAST_DOWNLOAD.success, Types.DASHBOARD_CDD_LAST_DOWNLOAD.failure],
    })
}

export { Types, fetchMediaLatest, fetchMediaScheduledNext, fetchCDDLastDownload }
